<div class="zone-panel" data-element="zone-panel">
  <fieldset class="fieldset" data-element="fieldset-current-zone">
    <legend>Current Zone</legend>
    <div class="zone-center">
      <p class="zone-value" data-element="zone-value">{{ this.displayZone }}</p>
      <p class="note" data-element="zone-rule-caption">
        Re-Evaluated on a Daily Basis
      </p>
    </div>
  </fieldset>
</div>
